import React, { useState } from 'react';
import classNames from 'classnames';
import styles from '../assets/bonus-grid.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from 'src/components/react-table/Grid';
import textFilter from 'src/components/react-table/filters/text-filter';
import { QueryParams } from 'src/types/grid';
import { IBonus } from 'src/types/bonus';
import GeneralEnumService from 'src/enumerables/general-enum';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';
import { CellProps } from 'react-table';
import { ICase } from 'src/types/case';
import dropdownFilter from 'src/components/react-table/filters/dropdown-filter';
import { changeToZeroMoment } from 'src/helpers/timeHelpers';
import moment from 'moment';
import { IInvoice } from 'src/types/invoice';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import dateFilterMulti from 'src/components/react-table/filters/date-filter-multi';
import { numberWithCommas } from '../../../../../../../helpers/format';

interface Props {
    data: Paginated<IBonus>;
    providers: SelectObject[];
    getData: (params: QueryParams) => void;
    getDataCsv: (params: QueryParams) => void;
}

const GeneralEnum = GeneralEnumService ? GeneralEnumService.getEnum('BonusStatus') : {};
const statusItems: SelectObject[] = getValFromEnum(GeneralEnum);

const GeneralEnumType = GeneralEnumService ? GeneralEnumService.getEnum('BonusType') : {};
const typeItems: SelectObject[] = getValFromEnum(GeneralEnumType);

const getColumns = (dataProd: SelectObject[]): Column<IBonus>[] => [
    {
        Header: 'Provider',
        accessor: 'provider.id',
        disableSortBy: true,
        Filter: dropdownFilter<IBonus>(dataProd),
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IBonus>) => {
            if (!original?.provider) return '';

            return (
                <Link
                    to={Router.generate(routes.PROVIDER_DETAIL, {
                        id: original?.provider?.id,
                        tab: 'main-info',
                        subId: '',
                    })}
                >
                    {original.provider?.fullName}
                </Link>
            );
        },
        // Filter: dropdownFilter<IBonus>(),
    },
    {
        Header: 'Referred Provider',
        accessor: 'referral.id',
        disableSortBy: true,
        Filter: dropdownFilter<IBonus>(dataProd),
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IBonus>) => {
            if (!original?.referral) return '';

            return (
                <Link
                    to={Router.generate(routes.PROVIDER_DETAIL, {
                        id: original?.referral?.id,
                        tab: 'main-info',
                        subId: '',
                    })}
                >
                    {original.referral?.fullName}
                </Link>
            );
        },
    },
    {
        Header: 'Note',
        accessor: 'info',
        disableSortBy: true,
        disableFilters: true,
        Filter: textFilter<IBonus>(),
    },
    {
        Header: 'Date',
        accessor: 'createdAt',
        disableSortBy: true,
        headerClassName: 'text-center w-100 d-block',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IBonus>) => {
            return (
                <div className={'text-center'}>
                    {original.createdAt ? changeToZeroMoment(original.createdAt, 'MMM D, YYYY') : ''}
                </div>
            );
        },
        Filter: dateFilterMulti<IBonus>(),
    },
    {
        Header: 'Amount $',
        accessor: 'amount',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IBonus>) => {
            return original.amount ? `$${numberWithCommas(original.amount)}` : null;
        },
        Filter: textFilter<IBonus>(),
    },
    {
        Header: 'Type',
        accessor: 'bonusType',
        disableSortBy: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IBonus>) => {
            const valueTYpe = typeItems.find((it) => it.value === original.bonusType);
            return valueTYpe ? valueTYpe.label : '';
        },
        Filter: dropdownFilter<IBonus>(typeItems),
    },
    {
        Header: 'Status',
        accessor: 'status',
        disableSortBy: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICase>) => {
            const valueCaseStatus = statusItems.find((it) => it.value === original.status);
            return valueCaseStatus ? valueCaseStatus.label : '';
        },
        Filter: dropdownFilter<IBonus>(statusItems),
    },
];

const BonusesGrid: React.FunctionComponent<Props> = ({ data, getData, getDataCsv, providers }: Props) => {
    const [columns, setColumns] = useState<any>([]);

    if (providers.length && !columns.length) {
        setColumns(getColumns(providers));
    }
    return (
        <div className={classNames(styles.grid)}>
            <Grid<IBonus> columns={columns} data={data} getDataCsv={getDataCsv} getData={getData} />
        </div>
    );
};

export default BonusesGrid;
